<template>
    <my-input
        type="div"
        :label="label"
        :required="required"
        :id="id"
        :input-class="inputClass"
        :validator="validator"
        :error-message="errorMessage"
        :info="info"
    >
        <div
            slot="custom"
        >
            <label class="radio" v-for="ro in radioOptions">
                <input
                    type="radio"
                    :name="name"
                    :value="ro.value"
                    :checked="ro.checked"
                    @change="onChange"
                >
                {{ ro.label }}
            </label>
        </div>
    </my-input>
</template>

<script>
import MyInput from "./MyInput";
export default {
    components: {
        MyInput,
    },
    // inheritAttrs: false,
    props: {
        name: {
            type: String,
        },
        radioOptions: {
            type: Array,
            default() {
                return [];
            },
        },
        label: {
            type: String,
            default: '',
        },
        required: {
            type: Boolean,
            default: false,
        },
        id: {
            type: String,
            default: '',
        },
        inputClass: {
            type: [String, Array, Object],
            default() { return []; },
        },
        value: {
            type: [Number, String, Boolean],
            default: '',
        },
        validator: {
            type: Object,
            default: null,
        },
        errorMessage: {
            type: String,
            default: '',
        },
        info: {
            type: String,
        },
    },
    data() {
        return {
            myValue: this.value,
        }
    },
    watch: {
        value(cur, prev) {
            this.myValue = cur;
        },
    },
    methods: {
        onChange($event) {
            this.validator && this.validator.$touch();
            this.myValue = $event.target.value;
            this.$emit('change', $event.target.value);
        },
    }
}
</script>

<style scoped>
label.radio:first-of-type {
    margin-left: -10px;
}
label.radio:not(:first-of-type) {
    margin-left: 25px;
}

</style>
